// /* eslint-disable */
// import ability from './ability'

// export const canNavigate = to => to.matched.some(route => {
//   if (Array.isArray(route.meta.resource)) {
//     return route?.meta?.resource?.some(el => ability.can(route.meta.action == 'read', el))
//   }
//   return ability.can(route.meta.action == 'read', route.meta.resource)
// })



import ability from './ability'

export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))

// export const _ = undefined